import * as types from './mutation-types'
import { Auth } from '../api/'
import { AdminLogin } from '../api/'

export default {
  logout: ({ commit, state }) => {
    return Auth.logout(state.auth.token)
      .then((responce) => {
        localStorage.removeItem('token')
        commit(types.ADMIN_AUTH_LOGOUT)
      })
      .catch(err => { throw err })
  },
  getUserInfo: ({ commit }, param) => {
    return AdminLogin.getUserInfo({ param })
      .then((ircd, irnm) => {
        commit(types.ADMIN_USERINFO_SETUSERINFO, { ircd, irnm })
      })
      .catch(err => { throw err })
  }
}



// WEBPACK FOOTER //
// ./src/store/actions.js